import { AvatarGroup } from "@dash/avatar";
import { Dialog, useDialogRoute } from "@dash/dialog";
import { useDeviceType } from "@dash/mq";
import { Card, Header2 } from "@dash/page";
import { useQueryClient } from "react-query";

import { Profile } from "@megaron/auth-contracts";

import { ExtendedMacroregion } from "./MacroregionsTable";
import { RealizationProgressBar } from "./RealizationProgressBar";
import { RegionChips } from "./RegionChips";
import { SaveMacroregion } from "./SaveMacroregion";

type Props = {
  macroregion: ExtendedMacroregion;
  profiles?: Profile[];
  queryKey: string | string[];
};

export const MacroregionTile: React.FC<Props> = (props) => {
  const queryClient = useQueryClient();
  const { isMobile } = useDeviceType();

  const { macroregion, profiles, profitMetrics } = props.macroregion;

  const updateRegionDialog = useDialogRoute(`/${macroregion.name}`, ({ onClose }) => (
    <Dialog
      onClose={onClose}
      header={macroregion.name}
      placement={isMobile ? "bottom" : "center"}
      css={{ width: isMobile ? "100%" : "500px" }}
    >
      <SaveMacroregion
        macroregion={macroregion}
        onSuccess={() => {
          queryClient.invalidateQueries(props.queryKey);
          onClose();
        }}
      />
    </Dialog>
  ));

  return (
    <>
      <Card variant="secondary" css={{ cursor: "pointer" }} onClick={updateRegionDialog.open}>
        <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <Header2 css={{ fontSize: "16px", fontWeight: "bold" }}>{macroregion.name}</Header2>
            <span>
              {macroregion.customerCount} {macroregion.customerCount === 1 ? "klient" : "klientów"}
            </span>
          </div>
          <AvatarGroup
            profiles={
              profiles?.map((profile) => ({
                ...profile,
                firstName: profile.firstName ?? null,
                lastName: profile.lastName ?? null,
              })) ?? []
            }
            fullName
          />
        </div>
        {profitMetrics.profit && profitMetrics.target && (
          <RealizationProgressBar
            currentRealization={profitMetrics.profit?.toNumber()}
            goalRealization={profitMetrics.target?.toNumber()}
          />
        )}
        <RegionChips regions={macroregion.regions} />
      </Card>
      {updateRegionDialog.element}
    </>
  );
};
